import React, { Component } from 'react'

import gsap from 'gsap';

import { throttle } from 'lodash';
import { getDistanceFromTop } from '../../utils/position.js'


import './Mouse.css'

class Mouse extends Component {

    constructor(props) {

        super(props)

        this.state = {
            show: true,
            threshold: 200
        }

        this.scroll = this.scroll.bind(this);
        this.bind = this.bind.bind(this);
        this.removeBind = this.removeBind.bind(this);

    }


    scroll(e) {


        let top = getDistanceFromTop()

        let show = (top > this.state.threshold) ? false : true

        this.setState({
            show
        });

    }


    componentWillUnmount() {
        this.removeBind();
    }


    bind() {
        window.addEventListener('scroll', this.cb)
    }

    removeBind() {
        window.removeEventListener('scroll', this.cb)

        if(typeof this.tween !== 'undefined'){
            this.tween.kill()
        }
    }


    componentDidMount() {

        this.tween = gsap.timeline({
            repeat: -1
        })

        this.tween.to(this.wheel, {
            duration: 1,
            bottom: 0,
            ease: 'power4.in'
        }).to(this.wheel, {
            duration: 1,
            top: 100,
            ease: 'power4.in'
        })

        this.cb = throttle(this.scroll)

        this.bind();
    }

    render() {

        const mouseStyle = {
            height: this.state.show ? 100 : 0
        }

        return (

            <div className="mouse" style={mouseStyle}>
               <div className="wheel" ref={(wheel) => { this.wheel = wheel }}></div>
                <div className="outline">
                </div>
            </div>

        );
    }
}

export default Mouse;
